module.exports = __webpack_public_path__ + "static/media/map-picker-blue.144a5807.svg";